
        var result = require("!!../../../node_modules/css-loader/index.js!./home.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = 236
// module chunks = 0